import l from "./index754.js";
import { withDirectives as s, openBlock as t, createElementBlock as a, normalizeClass as r, createElementVNode as o, toDisplayString as i, renderSlot as n, vShow as p } from "vue";
import u from "./index720.js";
function f(e, m, c, d, b, g) {
  return s((t(), a(
    "ul",
    {
      ref: "groupRef",
      class: r(e.ns.be("group", "wrap"))
    },
    [
      o(
        "li",
        {
          class: r(e.ns.be("group", "title"))
        },
        i(e.label),
        3
        /* TEXT, CLASS */
      ),
      o("li", null, [
        o(
          "ul",
          {
            class: r(e.ns.b("group"))
          },
          [
            n(e.$slots, "default")
          ],
          2
          /* CLASS */
        )
      ])
    ],
    2
    /* CLASS */
  )), [
    [p, e.visible]
  ]);
}
var w = /* @__PURE__ */ u(l, [["render", f]]);
export {
  w as default
};
